"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _full = _interopRequireDefault(require("./full"));

var _bare = _interopRequireDefault(require("./bare"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = slim;
exports.default = _default;
/**
 * `slim` is the default function exported by `slimconf`
 */

function slim(a, fn) {
  return fn ? (0, _full.default)(a, fn) : (0, _bare.default)(a);
}